// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__Cc11s","count":"CardContentComponent_count__I6uVS"};